import React, { useState, useEffect } from 'react';
import Header from './gapsy-header';
import Navigation from './gapsy-Anavigation';
import Footer from './gapsy-footer';
import "bootstrap/dist/css/bootstrap.min.css"
import 'bootstrap-icons/font/bootstrap-icons.css';
import styles from '../assets/css/gapsy-dashboard.module.css';
import tabStyles from '../assets/css/gapsy-tabs.module.css';
import { List_Checker, Add_User, Modify_User, ListAllusers, ListAlldept, Getlocations } from "../components/ApiProperty";
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import formStyles from '../assets/css/gapsy-form.module.css';
import { BiSortUp, BiSortDown, BiSort } from "react-icons/bi";
import tableStyles from '../assets/css/sharedTableStyles.module.css';
import { tableCellStyle2, UsersPagination } from "../components/TableProperty";
import { Modal } from 'react-bootstrap';
import { SearchBox, UploadLoadingIcon } from "../components/Propertyfile";

const GapsyUserModify = () => {
    const [activeTab, setActiveTab] = useState('ldap'); // 'manual' or 'ai'
    const [users, setUsers] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [filteredUsers, setFilteredUsers] = useState([]);
    const usersItemsPerPage = 7; // Set the number of items per page
    const navigate = useNavigate();
    const [userPerPage, setUsersPerPage] = useState(1); // Set the initial page to 1
    const [showModalLdap, setShowModalLdap] = useState(false);
    const [editIndex, setEditIndex] = useState(null);
    const [checkerData, setCheckerData] = useState(null);
    const [message, setMessage] = useState("");
    const [modalMessage, setModalMessage] = useState('');
    const [messageType, setMessageType] = useState(''); // 'success', 'warning', or 'error'


    const [selectedOption, setSelectedOption] = useState('All');
    const [disableInputs, setDisableInputs] = useState(false);
    const [passwordGenerated, setPasswordGenerated] = useState(false);
    const [searchQuery, setSearchQuery] = useState('');
    const [selectedLocationValues, setSelectedLocationValues] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [showNoRecordsModal, setShowNoRecordsModal] = useState(false);
    const [mode, setMode] = useState("");
    const [departments, setDepartments] = useState([]); // Initialize as empty array
    const [formData, setFormData] = useState({
        adminId: '',
        userId: '',
        userFirstName: '',
        userLastName: '',
        userEmail: '',
        userPassword: '',
        userRole: '',
        orgHierarchy: '',
        userLocation: '',
        active_yn: '',
        mappedId: '',
        searchUserId: '' // Add this line
    });
    const [initialData, setInitialData] = useState({});
    const [selectedRole, setSelectedRole] = useState('');
    const [hierarchy, setHierarchy] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'userId', direction: 'asc' });
    const [error, setError] = useState("");
    const [selectedStatus, setSelectedStatus] = useState('');
    const [selectedChecker, setSelectedChecker] = useState('');

    let csrfToken = sessionStorage.getItem("tokenizedSession");

    useEffect(() => {
        const fetchUsers = async () => {
            try {
                setIsLoading(true);
                const config = {
                    params: { "adminId": localStorage.getItem('userid') },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                }
                const response = await axios.post(ListAllusers, {}, config);

                setUsers(response.data.users);
                setFilteredUsers(response.data.users);
                setIsLoading(false);
            } catch (error) {
                console.error('There was an error fetching the users!', error);
                setIsLoading(false);
            }
        };
        fetchUsers();
    }, []);


    useEffect(() => {
        const fetchDepartments = async () => {
            const sessionDept = sessionStorage.getItem("dept");

            try {
                // Fetch all departments for everyone
                const deptConfig = {
                    headers: {
                        userId: localStorage.getItem('userid'),
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                };

                const response = await axios.post(ListAlldept, {}, deptConfig);

                if (response.data?.department && Array.isArray(response.data.department)) {
                    const allDepartments = response.data.department.map((name, index) => ({
                        id: index + 1,
                        name
                    }));

                    if (sessionDept === "IT") {
                        // IT users see all departments
                        setDepartments(allDepartments);
                    } else {
                        // Non-IT users see all departments but their own department is selected by default
                        setDepartments(allDepartments);

                        // Set their department as the initial value in the form
                        setFormData(prev => ({
                            ...prev,
                            orgHierarchy: sessionDept
                        }));
                    }
                } else {
                    // Fallback to just their department if API fails
                    setDepartments([{ id: 1, name: sessionDept }]);
                    setFormData(prev => ({
                        ...prev,
                        orgHierarchy: sessionDept
                    }));
                }
            } catch (error) {
                console.error('Error fetching departments:', error);
                // Fallback to just their department if API fails
                setDepartments([{ id: 1, name: sessionDept }]);
                setFormData(prev => ({
                    ...prev,
                    orgHierarchy: sessionDept
                }));
            }
        };

        fetchDepartments();
    }, []);


    const handleShow = (isEdit = false, mode) => {
        if (!isEdit) {
            setFormData({ adminId: '', userId: '', userFirstName: '', userLastName: '', userEmail: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
            setInitialData(users);
            setEditIndex(isEdit);
        }
        setError(null);
        setMode(mode);
        setShowModal(true);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        const updatedFormData = {
            ...formData,
            adminId: localStorage.getItem('userid') || ''
        };

        const isEdited = JSON.stringify(updatedFormData) !== JSON.stringify(initialData);

        if (!isEdited) {
            setMessageType('warning');
            setModalMessage("No changes were made.");
            setTimeout(() => handleCloseModal(), 5000);
            return;
        }

        try {
            if (editIndex !== null) { // Edit Mode
                const { adminId, userId, userFirstName, userLastName, userRole, userEmail, orgHierarchy, userLocation, active_yn, mappedId } = updatedFormData;

                // Validate input fields
                if (!userId) {
                    setMessageType('error');
                    setModalMessage("User Id is required");
                    return;
                }
                if (!userFirstName) {
                    setMessageType('error');
                    setModalMessage("Firstname is required");
                    return;
                }
                if (!userRole) {
                    setMessageType('error');
                    setModalMessage("User Role is required");
                    return;
                }
                if (userRole === 'Maker' && mappedId === "") {
                    setMessageType('error');
                    setModalMessage("Mapped ID is required for Maker role");
                    return;
                }
                if (!userEmail) {
                    setMessageType('error');
                    setModalMessage("Email Id is required");
                    return;
                }
                if (userEmail && !validateEmail(userEmail)) {
                    setMessageType('error');
                    setModalMessage('Please enter a valid email');
                    return;
                }
                if (!orgHierarchy) {
                    setMessageType('error');
                    setModalMessage("Hierarchy is required");
                    return;
                }
                setIsLoading(true);
                const config = {
                    params: { adminId, userId, userFirstName, userLastName: userLastName || "", userRole, userEmail, orgHierarchy, location: userLocation, active_yn, mappedId: mappedId || "" },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                };

                const response = await axios.post(Modify_User, {}, config);

                // Update the user in the state
                const updatedUsers = users.map(user =>
                    user.userId === userId ? { ...user, ...response.data.updatedFields } : user
                );

                setUsers(updatedUsers);
                setFilteredUsers(updatedUsers);
                setIsLoading(false);
                setMessageType('success');
                setModalMessage(response.data.message);
                setTimeout(() => handleCloseModal(), 5000);

            } else { // Add Mode
                const { adminId, userId, userFirstName, userLastName, userEmail, userPassword, userRole, orgHierarchy, userLocation, active_yn = "Y", mappedId } = updatedFormData;

                // Validate input fields
                if (!userId) {
                    setMessageType('error');
                    setModalMessage("User Id is required");
                    return;
                }
                if (!userFirstName) {
                    setMessageType('error');
                    setModalMessage("Firstname is required");
                    return;
                }
                if (!userEmail) {
                    setMessageType('error');
                    setModalMessage("Email Id is required");
                    return;
                }
                if (userEmail && !validateEmail(userEmail)) {
                    setMessageType('error');
                    setModalMessage('Please enter a valid email');
                    return;
                }
                if (!userPassword) {
                    setMessageType('error');
                    setModalMessage("Password has to be generated and it is required");
                    return;
                }
                if (!userRole) {
                    setMessageType('error');
                    setModalMessage("User Role is required");
                    return;
                }
                if (!orgHierarchy) {
                    setMessageType('error');
                    setModalMessage("Hierarchy is required");
                    return;
                }
                setIsLoading(true);
                const config = {
                    params: { adminId, userId, userFirstName, userRole, userLastName, userEmail, userPassword, orgHierarchy, userLocation, mappedId: mappedId || "", active_yn: 'Y' },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                };

                const response = await axios.post(Add_User, {}, config);

                // Add new user to the state
                const newUserActive = { ...response.data, active_yn: 'Y', newlyCreated: true };
                const updatedUsers = [...users, newUserActive];

                setUsers(updatedUsers);
                setFilteredUsers(updatedUsers);
                setIsLoading(false);
                setMessageType('success');
                setModalMessage(response.data.message);
                setInitialData({});
                setSelectedRole('');
                setHierarchy('');
                setPasswordGenerated(false);
                // Reset form data only in Add mode
                setFormData({ adminId: '', userId: '', userFirstName: '', userLastName: '', userEmail: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', mappedId: '' });
                setTimeout(() => handleCloseModal(), 5000);
            }
        } catch (error) {
            console.error('There was an error processing the user!', error);
            setIsLoading(false);
            setMessageType('error');
            setModalMessage('There was an error processing your request. Please try again.');
            setTimeout(() => handleCloseModal(), 5000);
        }
    };

    const handleCloseModal = () => {
        setModalMessage('');
        setMessageType('');
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prev) => ({ ...prev, [name]: value }));
    };


    const handleRoleChange = (e) => {
        const newRole = e.target.value;

        // Clear mappedId if changing from Checker to Maker
        if (selectedRole === 'Checker' && newRole === 'Maker') {
            localStorage.removeItem('mappedId');
        }

        setFormData({
            ...formData,
            userRole: newRole,
        });
        setSelectedRole(newRole);
    };

    const handleCloseLdap = () => {
        setShowModalLdap(false);
        setFormData({ adminId: '', userId: '', userFirstName: '', userLastName: '', userEmail: '', userPassword: '', userRole: '', orgHierarchy: '', userLocation: '', active_yn: '', mappedId: '' });
        setInitialData({});
        setEditIndex(null);
        setMessage('');
    };

    const handleFocus = (e) => {
        const { name } = e.target;
        if (!validateField(name)) {
            e.preventDefault();
        }
    };
    const handleHierarchyChange = async (hierarchyValue) => {
        // Update form state
        setFormData((prevFormData) => ({
            ...prevFormData,
            orgHierarchy: hierarchyValue,
        }));

        // Update hierarchy state
        setHierarchy(hierarchyValue);

        try {
            // 1. First API call - Fetch locations
            const locationResponse = await fetch(Getlocations, {
                method: 'POST',
                headers: {
                    'x-csrf-token': csrfToken // if needed
                },
            });
            if (!locationResponse.ok) {
                throw new Error('Failed to fetch location data');
            }

            const locationData = await locationResponse.json();
            // setSelectedLocationValues(locationData.location || []);
            setSelectedLocationValues(Array.isArray(locationData.location) ? locationData.location : []);

            // 2. Second API call - Fetch list of checkers (only if hierarchyValue means which we selected in dropdown)
            if (hierarchyValue) {
                const config = {
                    params: {
                        "adminId": localStorage.getItem('userid'),
                        "dept": hierarchyValue
                    },
                    headers: {
                        'x-csrf-token': csrfToken,
                    },
                    withCredentials: true
                };
                const checkersResponse = await axios.post(List_Checker, {}, config);
                setCheckerData(checkersResponse.data.checkers_list);

            }
        } catch (error) {
            console.error('Error in handleHierarchyChange:', error.message);
            setSelectedLocationValues([]);
            setCheckerData([]); // Reset checkers data on error
        }
    };

    const handleCheckers = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value
        });
        setSelectedChecker(e.target.value);
    };

    const handleUserStatus = (e) => {
        setFormData({
            ...formData,
            active_yn: e.target.value,
        });
        setSelectedStatus(e.target.value);
    };

    const validateField = (fieldName) => {
        if (fieldName === 'userFirstName' && !formData.userId) {
            setError('User Id is required');
            return false;
        }
        if (fieldName === 'userEmail' && !formData.userId) {
            setError('User Name is required');
            return false;
        }
        if (fieldName === 'userPassword' && !formData.userId) {
            setError('User Password is required');
            return false;
        }
        // Clear error message if validation passes
        setError(null);
        return true;
    };

    const handleDashboard = (e) => {
        e.preventDefault();
        navigate('/gapsyAdashboard');
        // Additional logic if needed
    };

    const validateEmail = (inputEmail) => {
        // Regular expression for basic email format validation
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return emailRegex.test(inputEmail);
    };

    const getSortedAndFilteredUsers = () => {
        const sortedFilteredUsers = [...filteredUsers].sort((a, b) => {
            // Prioritize newly created users
            if (a.newlyCreated && !b.newlyCreated) return -1;
            if (!a.newlyCreated && b.newlyCreated) return 1;

            const aValue = typeof a[sortConfig.key] === 'string' ? a[sortConfig.key].toLowerCase() : a[sortConfig.key];
            const bValue = typeof b[sortConfig.key] === 'string' ? b[sortConfig.key].toLowerCase() : b[sortConfig.key];

            if (aValue < bValue) {
                return sortConfig.direction === 'asc' ? -1 : 1;
            }
            if (aValue > bValue) {
                return sortConfig.direction === 'asc' ? 1 : -1;
            }
            return 0;
        });
        return sortedFilteredUsers;
    };

    const sortedAndFilteredUsers = getSortedAndFilteredUsers();

    const handleEdit = (userId, mode) => {
        if (!userId) {
            console.error("userId is undefined");
            return;
        }

        const userToEditIndex = sortedAndFilteredUsers.findIndex(user => user.userId === userId);
        const actualIndex = (userPerPage - 1) * usersItemsPerPage + userToEditIndex;

        if (userToEditIndex !== -1) {
            const selectedUser = sortedAndFilteredUsers[userToEditIndex];

            // Set the entire formData with the selected user info
            setFormData({
                ...selectedUser, // Spread the user's data into formData
                active_yn: selectedUser.active_yn || '' // Ensure active_yn is included, set default if undefined
            });

            setSelectedRole(selectedUser.userRole); // Assuming there's a selected role field
            setInitialData(selectedUser); // Track the initial data

            handleHierarchyChange(selectedUser.orgHierarchy);
            setEditIndex(actualIndex); // Set the actual index for editing
            setMode(mode); // Set mode to 'edit'
            handleShow(true, mode); // Show the modal
        }
    };


    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = (key) => {
        if (sortConfig.key !== key) {
            return <BiSort />;  // Neutral/no sort icon
        }
        return sortConfig.direction === 'ascending'
            ? <BiSortUp />
            : <BiSortDown />;
    };
    const renderUsersTable = () => {
        const startIndex = (userPerPage - 1) * usersItemsPerPage;
        const paginatedTableData = sortedAndFilteredUsers.slice(startIndex, startIndex + usersItemsPerPage);

        return paginatedTableData
            .filter((data) => data && data.userId) // Filter out undefined or null data
            .map((data) => (
                <tr
                    key={data.userId}
                    className={`${data.newlyCreated ? 'bg-success text-white' : ''}`}
                    style={{
                        transition: 'background-color 0.3s ease',
                    }}
                >
                    <td style={tableCellStyle2(startIndex)}>
                        {data.userId}
                    </td>
                    <td style={tableCellStyle2(startIndex)}>
                        {data.userFirstName}
                    </td>
                    <td style={tableCellStyle2(startIndex)}>
                        {data.userLastName}
                    </td>
                    <td style={tableCellStyle2(startIndex)}>
                        {data.userEmail}
                    </td>

                    <td style={tableCellStyle2(startIndex)}>
                        {data.orgHierarchy}
                    </td>
                    <td style={tableCellStyle2(startIndex)}>
                        {data.userLocation || "null"}
                    </td>
                    <td style={tableCellStyle2(startIndex)}>
                        {data.userRole}
                    </td>
                    <td style={tableCellStyle2(startIndex)}>
                        {data.mappedId}
                    </td>

                    <td style={tableCellStyle2(startIndex)}>
                        <i
                            className={`bi ${data.active_yn && data.active_yn.trim().toUpperCase() === 'Y' ? 'bi-toggle-on text-success' : 'bi-toggle-off text-danger'}`}
                            // onClick={() => handleToggle(data.userId)}
                            style={{ fontSize: '18px' }}
                        ></i>
                    </td>
                    <td style={{ width: '10%' }}>
                        <i
                            className='p-1 bi bi-pencil'
                            onClick={() => handleEdit(data.userId, "edit", false)}
                            title="Edit"
                            style={{ cursor: 'pointer' }}
                        ></i>
                    </td>
                </tr>
            ));
    };


    const handleSearch = (event) => {
        const query = event.target.value.toLowerCase();
        setSearchQuery(query);

        const filtered = users.filter(user => {
            const userId = user.userId.toString().toLowerCase();
            const userFirstName = (user.userFirstName?.toLowerCase()) || "";
            const userEmail = (user.userEmail?.toLowerCase()) || "";
            const userRole = (user.userRole?.toLowerCase()) || "";
            const location = (user.userLocation?.toLowerCase()) || "";
            return userId.includes(query) || userFirstName.includes(query) || userEmail.includes(query) || userRole.includes(query) || location.includes(query);
        });

        if (filtered.length === 0) {
            setShowNoRecordsModal(true);
            setSearchQuery('');
            setFilteredUsers(users);
        } else {
            setFilteredUsers(filtered);
        }
        setUsersPerPage(1); // Reset pagination to page 1 when search occurs
    };

    return (
        <div className={`d-flex flex-column min-vh-100 ${styles.pageFullBackground}`}>
            <Header />
            <Navigation />
            <div className="top-0 px-4 py-2 text-white">
                <div className="d-flex justify-content-between align-items-center flex-wrap">
                    <div>
                        <nav aria-label="breadcrumb">
                            <ol className="breadcrumb mb-1">
                                <li className="breadcrumb-item">
                                    <a onClick={handleDashboard} className={`text-info ${styles.textInfo}`} style={{ textDecoration: 'none' }}>
                                        <i className="bi bi-house me-2" style={{ cursor: "pointer" }}></i>/
                                    </a>
                                </li>
                                <li className={`breadcrumb-item active ${styles.breadcrumbItem}`} aria-current="page">
                                    <i className="bi bi-person-bounding-box me-2"></i>User Access Control
                                </li>
                            </ol>
                        </nav>
                    </div>
                </div>
            </div>
            <main className="flex-grow-1 container-fluid">
                <div className={styles.mainContainer}>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-lg-8 col-md-12 mx-auto">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">

                                        {/* Header + Search Row with single underline */}
                                        <div className={`d-flex justify-content-between align-items-center pb-2 mb-2 ${styles.borderBottom}`}>

                                            {/* Left: Heading */}
                                            <h6 className="mb-0">User Access Control</h6>

                                            {/* Right: Search Box */}
                                            <div >
                                                <SearchBox searchTerm={searchQuery} handleSearch={handleSearch} />
                                            </div>
                                        </div>
                                        {/* Table */}
                                        {isLoading ? (
                                            <div className="d-flex justify-content-center align-items-center" style={{ height: '200px' }}>
                                                <UploadLoadingIcon />
                                            </div>
                                        ) : (
                                            <div className="table-on-homepage-only mb-3">
                                                <div className={`tableWrapper ${tableStyles.tableWrapper}`}>
                                                    <table className={`table table-bordered table-hover text-center customScrollTable ${tableStyles.customScrollTable}`}>
                                                        <thead className="sticky-header">
                                                            {selectedOption !== 'All' && (
                                                                <tr className="rowFilter">
                                                                    <td colSpan="6">Applied Filter : {selectedOption}</td>
                                                                </tr>
                                                            )}
                                                            <tr>
                                                                <th onClick={() => requestSort('userId')}>
                                                                    UserId
                                                                    <span style={{ textAlign: 'center', padding: '5px' }}>
                                                                        {getSortIcon('userId')}
                                                                    </span>
                                                                </th>

                                                                <th onClick={() => requestSort('userFirstName')}>
                                                                    First Name
                                                                </th>
                                                                <th>Last Name</th>
                                                                <th>Email Id</th>
                                                                <th>Department</th>
                                                                <th>Location</th>
                                                                <th>Role</th>
                                                                <th>Assign Checker</th>
                                                                <th>Account Status</th>
                                                                <th>Modify</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>{renderUsersTable()}</tbody>
                                                    </table>
                                                </div>
                                            </div>
                                        )}


                                        {/* Pagination */}
                                        <div className="d-flex justify-content-end">
                                            <UsersPagination
                                                currentPage={userPerPage}
                                                itemsPerPage={usersItemsPerPage}
                                                totalItems={sortedAndFilteredUsers.length}
                                                onPageChange={setUsersPerPage}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-12">
                                <div className={`card h-100 ${styles.cardBorder} ${styles.card}`}>
                                    <div className="card-body">
                                        <div className="">
                                            <h6 className={`pb-1 mb-2 ${styles.borderBottom}`}>Modify User</h6>
                                            <div className={`mx-auto ${formStyles.formWrapper}`}>
                                                {isLoading && (
                                                    <>
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: 0,
                                                            left: 0,
                                                            right: 0,
                                                            bottom: 0,
                                                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                                                            zIndex: 1040
                                                        }} />
                                                        <div style={{
                                                            position: 'absolute',
                                                            top: '50%',
                                                            left: '50%',
                                                            transform: 'translate(-50%, -50%)',
                                                            zIndex: 1050
                                                        }}>
                                                            <div className="spinner-border text-dark" role="status">
                                                                <span className="visually-hidden">Loading...</span>
                                                            </div>
                                                        </div>
                                                    </>
                                                )}
                                                {mode === "edit" ? (
                                                    <form className="form" onSubmit={handleSubmit}>
                                                        <div className="form-group row">
                                                            <div className="col-sm-12">
                                                                <input
                                                                    type="hidden"
                                                                    name="adminId"
                                                                    value={localStorage.getItem('userid')}
                                                                    readOnly
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-group row mb-2 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">USER ID</label>
                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    name="userId"
                                                                    value={formData.userId}
                                                                    onChange={handleChange}
                                                                    onFocus={handleFocus}
                                                                    disabled={mode === "edit"}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">FIRST NAME</label>
                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    name="userFirstName"
                                                                    value={formData.userFirstName}
                                                                    onChange={handleChange}
                                                                    onFocus={handleFocus}
                                                                    disabled={disableInputs}
                                                                />
                                                            </div>
                                                        </div>
                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">LAST NAME</label>
                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    name="userLastName"
                                                                    value={formData.userLastName}
                                                                    onChange={handleChange}
                                                                    onFocus={handleFocus}
                                                                    disabled={disableInputs}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">EMAIL ID</label>
                                                            <div className="col-sm-7">
                                                                <input
                                                                    type="text"
                                                                    className="form-control form-control-sm"
                                                                    name="userEmail"
                                                                    value={formData.userEmail}
                                                                    onChange={handleChange}
                                                                    onFocus={handleFocus}
                                                                    disabled={disableInputs}
                                                                />
                                                            </div>
                                                        </div>

                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">DEPARTMENT</label>
                                                            <div className="col-sm-7">
                                                                <select
                                                                    className="form-select form-select-sm"
                                                                    name="orgHierarchy"
                                                                    onChange={(e) => handleHierarchyChange(e.target.value)}
                                                                    value={formData.orgHierarchy}
                                                                >
                                                                    <option value="">Select a Department</option>
                                                                    {departments
                                                                        .slice()
                                                                        .sort((a, b) => a.name.localeCompare(b.name))
                                                                        .map((dept) => (
                                                                            <option key={dept.id} value={dept.name}>
                                                                                {dept.name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                        <div className="form-group row mb-1 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">LOCATION</label>
                                                            <div className="col-sm-7">
                                                                <select
                                                                    className="form-select form-select-sm"
                                                                    name="userLocation"
                                                                    onChange={(e) => setFormData({ ...formData, userLocation: e.target.value })}
                                                                    value={formData.userLocation}
                                                                >
                                                                    <option value="">Select a Location</option>
                                                                    {Array.isArray(selectedLocationValues) &&
                                                                        selectedLocationValues
                                                                            .slice()
                                                                            .sort((a, b) => a.localeCompare(b))
                                                                            .map((loc, index) => (
                                                                                <option key={index} value={loc}>
                                                                                    {loc}
                                                                                </option>
                                                                            ))}
                                                                </select>
                                                            </div>
                                                        </div>

                                                        <div className="form-group row mb-1 mt-2 d-flex align-items-center">
                                                            <label className="col-sm-4 col-form-label small text-muted">ROLE</label>
                                                            <div className="col-sm-7">
                                                                <div className="row g-2">
                                                                    <div className="col-md-4 d-flex align-items-center">
                                                                        <input
                                                                            type="radio"
                                                                            name="userRole"
                                                                            value="Admin"
                                                                            checked={selectedRole === 'Admin'}
                                                                            onChange={handleRoleChange}
                                                                            className="form-check-input me-1"
                                                                        />
                                                                        <label className="mb-0 ms-1 small text-muted">Manager</label>
                                                                    </div>
                                                                    <div className="col-md-4 d-flex align-items-center">
                                                                        <input
                                                                            type="radio"
                                                                            name="userRole"
                                                                            value="Checker"
                                                                            checked={selectedRole === 'Checker'}
                                                                            onChange={handleRoleChange}
                                                                            className="form-check-input me-1"
                                                                        />
                                                                        <label className="mb-0 ms-1 small text-muted">Checker</label>
                                                                    </div>
                                                                    <div className="col-md-4 d-flex align-items-center">
                                                                        <input
                                                                            type="radio"
                                                                            name="userRole"
                                                                            value="Maker"
                                                                            checked={selectedRole === 'Maker'}
                                                                            onChange={handleRoleChange}
                                                                            className="form-check-input me-1"
                                                                        />
                                                                        <label className="mb-0 ms-1 small text-muted">Maker</label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>

                                                        {selectedRole === 'Maker' && (checkerData?.length ?? 0) > 0 && (
                                                            <div className="form-group row mb-1 d-flex align-items-center">
                                                                <label className="col-sm-4 col-form-label small text-muted">ASSIGN CHECKER</label>
                                                                <div className="col-sm-7">
                                                                    <select
                                                                        className="form-select form-select-sm"
                                                                        name="mappedId"
                                                                        value={formData.mappedId}
                                                                        onChange={handleCheckers}
                                                                    >
                                                                        <option value="">Select a Checker</option>
                                                                        {checkerData.map(checker => (
                                                                            <option key={checker.userId} value={checker.userId}>
                                                                                {checker.userName}
                                                                            </option>
                                                                        ))}
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )}

                                                        {mode === 'edit' && (
                                                            <div className="form-group row mb-1 d-flex align-items-center">
                                                                <label className="col-sm-4 col-form-label small text-muted">USER STATUS</label>
                                                                <div className="col-sm-7">
                                                                    <select
                                                                        className="form-select form-select-sm"
                                                                        name="active_yn"
                                                                        onChange={handleUserStatus}
                                                                        value={formData.active_yn || ''}
                                                                    >
                                                                        <option value="">Select User Status</option>
                                                                        <option value="Y">Active</option>
                                                                        <option value="N">Inactive</option>
                                                                    </select>
                                                                </div>
                                                            </div>
                                                        )}

                                                        <div className="form-group row mt-2 ms-1">
                                                            <div className="col-sm-4"></div>
                                                            <div className="col-sm-7 d-flex">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-secondary me-2 flex-grow-1"
                                                                    onClick={handleCloseLdap}
                                                                >
                                                                    Clear
                                                                </button>
                                                                <button
                                                                    type="submit"
                                                                    className="btn btn-sm btn-primary flex-grow-1"

                                                                    disabled={disableInputs}
                                                                >
                                                                    Save
                                                                </button>
                                                            </div>
                                                        </div>
                                                    </form>
                                                ) : (
                                                    <div className="text-center py-4">
                                                        <p className="text-muted small">Select a user to modify</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            {/* Modal for messages */}
                            <Modal
                                show={!!modalMessage}
                                onHide={handleCloseModal}
                                backdrop="static"
                                keyboard={false}
                                style={{ marginTop: '12vh' }}
                            >
                                <div
                                    className={`alert alert-${messageType === 'success' ? 'success' : messageType === 'warning' ? 'warning' : 'danger'} alert-dismissible fade show`}
                                    role="alert"
                                    style={{ marginBottom: '0' }}
                                >
                                    <div className="d-flex align-items-center">
                                        {messageType === 'success' ? (
                                            <span className="me-2" style={{ color: 'green', fontSize: '14px' }}>✅</span>
                                        ) : messageType === 'warning' ? (
                                            <span className="me-2" style={{ color: '#ffc107', fontSize: '14px' }}>⚠️</span>
                                        ) : (
                                            <span className="me-2" style={{ color: 'red', fontSize: '14px' }}>❌</span>
                                        )}
                                        <p
                                            style={{
                                                display: 'inline',
                                                marginBottom: '0px',
                                                color: messageType === 'success'
                                                    ? 'green'
                                                    : messageType === 'warning'
                                                        ? '#ffc107'
                                                        : 'red'
                                            }}
                                        >
                                            {modalMessage}
                                        </p>
                                    </div>
                                    <button
                                        type="button"
                                        className="btn-close"
                                        onClick={handleCloseModal}
                                        style={{ width: '15px', height: '15px', fontSize: '8px', position: 'absolute', bottom: '10px', right: '10px' }}
                                    />
                                </div>
                            </Modal>
                        </div>
                    </div>
                </div>
            </main>
            <Footer />
        </div>
    );
};

export default GapsyUserModify;
